export default __webpack_public_path__ + "static/media/visa.a5f11911.png";